import { useQuery } from '@tanstack/react-query';

import { listOfPlans } from '@/lib/api';

export const getPlans = async () => {
  const { data } = await listOfPlans();
  return data;
};

export const usePlans = () => {
  return useQuery({
    queryKey: ['plans'],
    queryFn: getPlans,
  });
};
